import { useOrganizationQuery, useCreateOrganizationMutation, useUpdateOrganizationMutation, useDeleteOrganizationMutation } from './useOrganizationsQuery';
import { Organization } from '../types';

export const useOrganization = (organizationId?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = useOrganizationQuery(organizationId || '');
    const createOrganizationMutation = useCreateOrganizationMutation();
    const updateOrganizationMutation = useUpdateOrganizationMutation();
    const deleteOrganizationMutation = useDeleteOrganizationMutation();

    const createRecord = async (values: Organization) => {
        return await createOrganizationMutation.mutateAsync(values);
    };

    const updateRecord = async (values: Organization) => {
        if (typeof organizationId === 'undefined') {
            throw new Error('organizationId is required parameter');
        }
        return await updateOrganizationMutation.mutateAsync({ id: organizationId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof organizationId === 'undefined') {
            throw new Error('organizationId is required parameter');
        }
        return await deleteOrganizationMutation.mutateAsync(organizationId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
